import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Modal,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import HostelWorkersList from "./HostelWorkersList";

const ViewHostelWorkers = ({ hostelWorkersData }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const view = (row) => {
    navigate(`/add-hostel-workers`, { state: row });
  };

  const [isFormOpen, setIsFormOpen] = useState(false);

  const hostelWorkers = [
    {
      id: 1,
      name: "Rajpal",
      father_name: "Ram",
      post: "Manager",
      date_of_birth: "1990-01-01",
      gender: "Male",
      doj: "2023-01-01",
      phone_number: "3234567890",
      aadhaar: "Aadhaar Number",
      staff_pan: "PAN Number",
      hostel_name: "Sample Hostel",
    },
    {
      id: 2,
      name: "qwertyu",
      father_name: "poiuytre",
      post: "Supervisor",
      date_of_birth: "1995-05-15",
      gender: "Female",
      doj: "2023-02-15",
      phone_number: "9876543210",
      aadhaar: "Aadhaar Number",
      staff_pan: "PAN Number",
      hostel_name: "Another Hostel",
    },
  ];

  const handleCloseForm = () => {
    setIsFormOpen(false);
  };

  return (
    <div className="px-0 px-md-3">
      <div className="mb-4 col-12 d-flex justify-content-between align-items-center">
        <h5 className="my-4">{t("Hostel Workers List")}</h5>
        <div>
          <button className="btn btn-sm" id="btn" onClick={() => view()}>
            {"Add Hostel Staff"}
          </button>
        </div>
      </div>

      <TableContainer component={Paper} className="mt-4 fluid">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t("Name")}</TableCell>
              <TableCell>{t("Father's Name")}</TableCell>
              <TableCell>{t("Post")}</TableCell>
              <TableCell>{t("Date of Birth")}</TableCell>
              <TableCell>{t("Gender")}</TableCell>
              <TableCell>{t("Date of Joining")}</TableCell>
              <TableCell>{t("Phone Number")}</TableCell>
              <TableCell>{t("Aadhaar")}</TableCell>
              <TableCell>{t("PAN Card")}</TableCell>
              <TableCell>{t("Hostel Name")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {hostelWorkers.map((worker) => (
              <TableRow key={worker.id}>
                <TableCell sx={{ borderBottom: "none" }}>
                  {worker.name}
                </TableCell>
                <TableCell sx={{ borderBottom: "none" }}>
                  {worker.father_name}
                </TableCell>
                <TableCell sx={{ borderBottom: "none" }}>
                  {worker.post}
                </TableCell>
                <TableCell sx={{ borderBottom: "none" }}>
                  {worker.date_of_birth}
                </TableCell>
                <TableCell sx={{ borderBottom: "none" }}>
                  {worker.gender}
                </TableCell>
                <TableCell sx={{ borderBottom: "none" }}>
                  {worker.doj}
                </TableCell>
                <TableCell sx={{ borderBottom: "none" }}>
                  {worker.phone_number}
                </TableCell>
                <TableCell sx={{ borderBottom: "none" }}>
                  {worker.aadhaar}
                </TableCell>
                <TableCell sx={{ borderBottom: "none" }}>
                  {worker.staff_pan}
                </TableCell>
                <TableCell sx={{ borderBottom: "none" }}>
                  {worker.hostel_name}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {isFormOpen && <HostelWorkersList onClose={handleCloseForm} />}
    </div>
  );
};

export default ViewHostelWorkers;
